const version: string = process.env.REACT_APP_VERSION || "";
export default version;
